import * as crypto from 'crypto-js'
import dayjs from 'dayjs'

import {
  ILineParams,
  IParamsToSend
} from '@base/@types/providers/Kpi/RuptureProvider'
const formatDate = (date: string) => {
  const newDate = date.split('/')
  return (
    Number(newDate[1]) + '-' + Number(newDate[0]) + '-' + Number(newDate[2])
  )
}

export const formatParamsModalKpiToSend = (
  dataLine: ILineParams,
  paramsToSend: IParamsToSend
) => {
  const paramsResponse = JSON.parse(
    crypto.AES.decrypt(
      localStorage.getItem('@kpiRuptureParamsResponse:'),
      'CHAVE'
    ).toString(crypto.enc.Utf8) || ''
  )
  const reptureIndicatorsRequestModal: IParamsToSend = {
    empresa: {
      ids: paramsToSend.empresa?.agrupar
        ? [dataLine['empresa-codigo-id']]
        : paramsToSend.empresa?.ids,
      agrupar: paramsToSend.empresa?.agrupar
    },
    tipoCentro: {
      ids: paramsToSend.tipoCentro?.ids,
      agrupar: paramsToSend.tipoCentro?.agrupar
    },
    loja: {
      ids: paramsToSend.loja?.agrupar
        ? [dataLine['cd-loja-codigo-id']]
        : paramsToSend.loja?.ids,
      agrupar: paramsToSend.loja?.agrupar
    },
    gerenteCategoria: {
      ids: paramsToSend.gerenteCategoria?.agrupar
        ? dataLine['gerente-categoria-id'] !== ''
          ? [
              paramsResponse.find(
                (item: any) =>
                  item.gerenteCategoriaDescricao ===
                  dataLine['gerente-categoria-id']
              )?.gerenteCategoriaId
            ]
          : []
        : paramsToSend.gerenteCategoria?.ids,
      agrupar: paramsToSend.gerenteCategoria?.agrupar
    },
    gerenteProduto: {
      ids: paramsToSend.gerenteProduto?.agrupar
        ? dataLine['gerente-produto-id'] !== ''
          ? [
              paramsResponse.find(
                (item: any) =>
                  item.gerenteProdutoDescricao ===
                  dataLine['gerente-produto-id']
              )?.gerenteProdutoId
            ]
          : []
        : paramsToSend.gerenteProduto?.ids,
      agrupar: paramsToSend.gerenteProduto?.agrupar
    },
    mundo: {
      ids: paramsToSend.mundo?.agrupar
        ? [dataLine['mundo-codigo-id']]
        : paramsToSend.mundo?.ids,
      agrupar: paramsToSend.mundo?.agrupar
    },
    categoriaCompacta: {
      ids: paramsToSend.categoriaCompacta?.agrupar
        ? [dataLine['categoria-compacta-codigo-id']]
        : paramsToSend.categoriaCompacta?.ids,
      agrupar: paramsToSend.categoriaCompacta?.agrupar
    },
    categoria: {
      ids: paramsToSend.categoria?.agrupar
        ? [dataLine['categoria-codigo-id']]
        : paramsToSend.categoria?.ids,
      agrupar: paramsToSend.categoria?.agrupar
    },
    statusEstoque: {
      ids: paramsToSend.statusEstoque?.agrupar
        ? dataLine['status-nome-id'] !== ''
          ? [
              paramsResponse.find(
                (item: any) =>
                  item.statusDescricao === dataLine['status-nome-id']
              )?.statusId
            ]
          : []
        : paramsToSend.statusEstoque?.ids,
      agrupar: paramsToSend.statusEstoque?.agrupar
    },
    curvaABC: {
      descricoes: paramsToSend.curvaABC?.agrupar
        ? dataLine['curva-abc-nome-id'] !== ''
          ? [
              paramsResponse.find(
                (item: any) =>
                  item.curvaABCDescricao === dataLine['curva-abc-nome-id']
              )?.curvaABCDescricao
            ]
          : []
        : paramsToSend.curvaABC?.descricoes,
      agrupar: paramsToSend.curvaABC?.agrupar
    },
    fornecedor: {
      ids: paramsToSend.fornecedor?.agrupar
        ? [dataLine['fornecedor-codigo-id']]
        : paramsToSend.fornecedor?.ids,
      agrupar: paramsToSend.fornecedor?.agrupar
    },
    subCategoria: {
      ids: paramsToSend.subCategoria?.agrupar
        ? [dataLine['subcategoria-codigo-id']]
        : paramsToSend.subCategoria?.ids,
      agrupar: paramsToSend.subCategoria?.agrupar
    },
    periodo: {
      inicio: dayjs(
        formatDate(dataLine['data-execucao-id'].toString()).toString()
      ).format('YYYY-MM-DD'),
      final: dayjs(
        formatDate(dataLine['data-execucao-id'].toString()).toString()
      ).format('YYYY-MM-DD'),
      agrupar: paramsToSend.periodo.agrupar
    }
  }
  return reptureIndicatorsRequestModal
}
